// extracted by mini-css-extract-plugin
module.exports = {"container":"AIEmbrace_container__1gUi4","title":"AIEmbrace_title__10ri8","sectionTitle":"AIEmbrace_sectionTitle__ZwxiW","paragraph":"AIEmbrace_paragraph__1TrKz"};